export default __webpack_public_path__ + "sounds/f958bdb7d84c023ae4f0469614da2ed2.mp3";